import { useState, useCallback, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useURLQuery } from './useURLQuery';
import { TABS_CONFIG } from '../utils/constants';

export const useTabManagement = () => {
  const history = useHistory();
  const location = useLocation();
  const query = useURLQuery();
  const tabParam = query.get('tab');
  const [selectedTab, setSelectedTab] = useState(() => {
    const index = TABS_CONFIG.findIndex((t) => t.id === tabParam);
    return index >= 0 ? index : 0;
  });

  useEffect(() => {
    if (!tabParam || !TABS_CONFIG.some((t) => t.id === tabParam)) {
      const params = new URLSearchParams(location.search);
      params.set('tab', TABS_CONFIG[0].id);

      history.replace({
        pathname: location.pathname,
        search: params.toString()
      });
    }
  }, []);

  useEffect(() => {
    if (tabParam) {
      const tabIndex = TABS_CONFIG.findIndex((tab) => tab.id === tabParam);
      if (tabIndex >= 0 && tabIndex !== selectedTab) {
        setSelectedTab(tabIndex);
      }
    }
  }, [tabParam, selectedTab]);

  const handleTabSelect = useCallback(
    (selectedTabIndex: number) => {
      setSelectedTab(selectedTabIndex);
      const params = new URLSearchParams(location.search);
      params.set('tab', TABS_CONFIG[selectedTabIndex].id);

      history.push({
        pathname: location.pathname,
        search: params.toString()
      });
    },
    [history, location]
  );

  return {
    selectedTab,
    handleTabSelect,
    tabs: TABS_CONFIG
  };
};
